


















































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";
//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'

//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: {OrganizationChart},

  data() {
    return {
    poa_series:[]as any,
    };
  },
  mixins: [poa_series
 
  ],
  methods: {
       async onClick() {
      var sTable = document.getElementById("tablaIndicador").innerHTML;
      await axios({
        url: this.$store.state.baseapi + "pdf",
        method: "POST",
        data: {
          html: sTable,
          title: "Ficha Indicador",
        },
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "file.pdf");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    onChangeS(event){
//console.log(event.target.value)
this.getDataSerie(event.target.value);

},
      
       async getDataSerie(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_POA_SERIES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_series=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

  },
  created() {},
  mounted() {   this.getDataSerie();
  
  },
})
export default class Home extends Vue {

  // @Prop() private id !:any;
}
